import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DataSearchResult } from '../../enums/enums'
import { DdcCountryFlagComponent } from '../ddc-country-flag/ddc-country-flag.component'

@Component({
  selector: 'ddc-search-result-pair',
  templateUrl: './ddc-search-result-pair.component.html',
  styleUrl: './ddc-search-result-pair.component.scss',
  imports: [CommonModule, AngularMaterialsModules, DdcCountryFlagComponent],
})
export class DdcSearchResultPairComponent {
  @Input() result!: DataSearchResult
  @Input() showIcon: boolean = true
  @Input() showTime: boolean = true
  @Output() pairClick = new EventEmitter<number>()

  onPairClick(): void {
    if (this.result?.id) {
      this.pairClick.emit(this.result.id)
    }
  }
}
